import React, {
  FormEvent,
  useEffect,
  useState,
} from "react";
import { Modal } from "react-bootstrap";
import CrossIcon from "../../../assets/img/order-details/cross.svg";

import "./index.scss";

interface SupplierData {
  name: string;
  email: string;
}

interface SendToSupplierProps {
  show: boolean;
  loading?: boolean;
  onHide: () => void;
  onSubmit: (data: SupplierData) => void;
}

export const SendToSupplier = ({
  show,
  loading = false,
  onHide,
  onSubmit,
}: SendToSupplierProps) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!show) {
      setName("");
      setEmail("");
    }
  }, [show]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    onSubmit({
      name: name.trim(),
      email: email.trim(),
    });
  };

  return (
    <Modal
      show={show}
      onHide={loading ? undefined : onHide}
      centered
      dialogClassName="send-to-supplier-modal"
      backdrop={loading ? "static" : true}
      keyboard={!loading}
    >
      <div className="send-to-supplier-head">
        <h4>שלח לספק</h4>

        {!loading && (
          <img
            src={CrossIcon}
            alt="סגירה"
            onClick={onHide}
          />
        )}
      </div>

      <form
        className="send-to-supplier-body"
        onSubmit={handleSubmit}
      >
        <label htmlFor="supplier-name">
          שם הספק
        </label>

        <input
          id="supplier-name"
          type="text"
          required
          value={name}
          placeholder="הקלד שם ספק"
          onChange={(event) =>
            setName(event.target.value)
          }
        />

        <label htmlFor="supplier-email">
          כתובת אימייל הספק
        </label>

        <input
          id="supplier-email"
          type="email"
          required
          value={email}
          placeholder="supplier@example.com"
          onChange={(event) =>
            setEmail(event.target.value)
          }
        />

        <button
          type="submit"
          disabled={loading}
        >
          {loading && (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              &nbsp;
            </>
          )}

          {loading ? "שולח..." : "שלח לספק"}
        </button>
      </form>
    </Modal>
  );
};

